import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';

VIV.behaviours.modalSearch = (function () {

    const baseClass = 'modalSearch';

    const attach = function (context) {
        context.querySelectorAll('.modalSearch').forEach(element => {
            if (element.classList.contains('js-active')) {
                return;
            }
            element.classList.add('js-active');
            init(element);
        });
    };

    const init = function (element) {
        const toggleButtons = document.querySelectorAll('.behaviourToggleSearch');
        toggleButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const isOpen = element.classList.contains(`${baseClass}--open`);
                isOpen ? closeModal(element) : openModal(element);
            });
        });
    };

    const closeModal = function (modal) {
        modal.classList.remove(`${baseClass}--open`);
        enableBodyScroll(modal);
        window.removeEventListener('keydown', onKeyPress);
    }

    const openModal = function (modal) {
        const input = modal.querySelector(`input`);
        modal.classList.add(`${baseClass}--open`);
        disableBodyScroll(modal);
        setTimeout(() => {
            input.focus();
        }, 200);
        window.addEventListener('keydown', onKeyPress);
    }


    const onKeyPress = function (e) {
        const modal = document.querySelector(`.${baseClass}--open`);
        if (e.key === "Escape") {
            closeModal(modal);
        }
    }

    return {
        attach: attach
    }
})();
